import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    if (!this.authService.isValidRefreshToken()) {
      this.router.navigateByUrl('/auth/login');
      return false;
    }

    const role = this.authService.readTypeUser();
    const url = state.url || '';

    if (role === 'Premium') {
      if (!url.startsWith('/premium')) {
        this.router.navigateByUrl('/premium');
        return false;
      }
      return true;
    }

    if (role === 'Standard') {
      if (!url.startsWith('/standard')) {
        this.router.navigateByUrl('/standard');
        return false;
      }
      return true;
    }

    return true;
  }
}
